import Request from "@/network/HttpRequest";
// 获取所有城市
export function getCityList() {
  return Request.get(`/yiautos-basic/region/getLetterGroup`);
}
